import { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { DEFAULT_POST_AUTH_PATH } from '../../rbac/landingPage';

export default function LoggedOutPage() {
  const { signIn, loading } = useAuth();

  useEffect(() => {
    // After a real logout, immediately redirect to the Keycloak login page.
    // `prompt=login` avoids silently reusing an existing SSO session.
    console.info('[auth] LoggedOutPage mounted, redirecting to keycloak login', { href: window.location.href });
    void signIn(DEFAULT_POST_AUTH_PATH, { promptLogin: true });
  }, [signIn]);

  return (
    <div className="state-wrap">
      <div className="state-card">
        <div className="state-title">Signed out</div>
        <div className="state-sub">{loading ? 'Redirecting to login…' : 'Redirecting to login…'}</div>
      </div>
    </div>
  );
}

